import React, { useEffect, useState } from "react";
import {
    Box, Typography, Button, Paper, TableBody, TableRow, TableCell,
    IconButton, Modal, Table, Radio
} from "@mui/material";
import { Drawer } from "@mui/material";
import SideNavToolbar from "../Components/SidenavToolbar";
import SideNavHeader from "../Components/SideNavHeader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { PAP_Locations_Getrow } from "../../../Server/ApiV2";
import { fAlertToast } from "../../../Utility/Utilitys";
import { useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import moment from "moment";
export default function AnalysisReport({
    open,
    onClose,
    selectedPromo,
    userCd,
    pageType,
    Summary
}) {
    const [locations, setLocations] = useState([]);
    const initialFilterObj = {
        dateFrom: moment().startOf("month").toDate(),
        dateTo: moment().toDate(),
        location: "",
    };
    const [filterObj, setFilterObj] = useState(initialFilterObj);
    const [openModal, setOpenModal] = useState(false);
    const [reportUrl, setReportUrl] = useState(false);
    const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    const fRadioSelect = (row) => {
        setFilterObj((prev) => ({
            ...prev,
            location: row.Loc,
            promoCode: row.PromoCd
        }));
    };
    const fLoadClick = () => {
        console.log("DATE FROM :", filterObj.dateFrom);
        console.log("DATE TO   :", filterObj.dateTo);
        console.log("LOCATION  :", filterObj.location);
        if (moment(filterObj.dateTo).isBefore(moment(filterObj.dateFrom))) {
            fAlertToast("FAILED", "To Date cannot be earlier than From Date");
            return;
        }
        if (!filterObj.location) {
            fAlertToast("FAILED", "Please select a location");
            return;
        }
        const url = `${urlPrint}WMS/PROMOTION?prntyp=PA&v_Date1=${moment(selectedPromo?.FromDt).format("DD/MM/YYYY")}&v_Date2=${moment(selectedPromo?.ToDt).format("DD/MM/YYYY")}&v_Loc=${filterObj.location}&ReportTitle=""&v_PrmCode=${filterObj.promoCode}&v_CDate1=${moment(filterObj.dateFrom).format("DD/MM/YYYY")}&v_CDate2=${moment(filterObj.dateTo).format("DD/MM/YYYY")}&v_UserCd=${userCd}&Stock=N`
        setReportUrl(url);
        console.log(reportUrl, 'reportUrl');

        setOpenModal(true);
    };
    const getPageRows = async () => {
        const response = await PAP_Locations_Getrow({
            TransId: selectedPromo?.TransId || "",
            UserCd: userCd,
        });

        if (response?.data?.status === "Success") {
            setLocations(response?.data?.recordset ?? []);
        } else {
            setLocations([]);
            fAlertToast("FAILED", response?.data?.message || "No records found");
        }
    };
    useEffect(() => {
        if (open) getPageRows();
    }, [open]);
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            transitionDuration={{ enter: 300, exit: 200 }}
            sx={{
                "& .MuiDrawer-paper": {
                    width: { xs: "70%", sm: "70%", md: "52%" },
                    borderRadius: "16px 0 0 16px",
                },
            }}
        >
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mt={5.1}
                    sx={{
                        position: "sticky",
                        top: 1,
                        zIndex: 10,
                        background: "linear-gradient(135deg, #1e88e5 0%, #673ab7 100%)",
                        color: "#fff",
                        px: 2,
                        py: 1.2,
                        borderBottom: "1px solid #1565c0",
                        flexShrink: 0,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <IconButton
                            edge="end"
                            onClick={() => {
                                setFilterObj(initialFilterObj);
                                onClose();
                            }}
                            sx={{
                                fontSize: "20px !important",
                                color: "#ffffff",
                                backgroundColor: "rgba(255,255,255,0.15)",
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="h6" sx={{ fontWeight: 500, ml: "22px" }}>
                            Analysis Report
                        </Typography>
                    </div>
                    <IconButton
                        onClick={() => {
                            setFilterObj(initialFilterObj);
                            onClose();
                        }}
                        sx={{
                            color: "#ffffff",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            "&:hover": { backgroundColor: "rgba(255,255,255,0.25)" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <SideNavToolbar
                    transId={selectedPromo?.TransId || ""}
                    userCd={userCd}
                    selectedRow={selectedPromo}
                    loadSummary={Summary}
                />
                <Box sx={{ p: 2, flex: 1, overflowY: "auto" }}>
                    <SideNavHeader selectedRow={selectedPromo} pageType={pageType} />
                    <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                        <CmpDatePickerField001V1
                            xLabelText="From Date"
                            xName="dateFrom"
                            xValue={filterObj.dateFrom}
                            xOnChange={(newValue) =>
                                setFilterObj((prev) => ({
                                    ...prev,
                                    dateFrom: newValue?.$d ?? newValue
                                }))
                            }
                        />
                        <CmpDatePickerField001V1
                            xLabelText="To Date"
                            xName="dateTo"
                            xValue={filterObj.dateTo}
                            xOnChange={(newValue) =>
                                setFilterObj((prev) => ({
                                    ...prev,
                                    dateTo: newValue?.$d ?? newValue
                                }))
                            }
                        />
                    </Box>
                    <Paper elevation={2} sx={{ mt: 2, p: 1.5, borderRadius: 3 }}>
                        <Table size="small">
                            <TableBody>
                                {locations.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? "#f5faff" : "#ffffff",
                                            "&:hover": { backgroundColor: "#e3f2fd" },
                                        }}
                                    >
                                        <TableCell sx={{ width: 50 }}>
                                            <Radio
                                                size="small"
                                                checked={filterObj.location === row.Loc}
                                                onChange={() => fRadioSelect(row)}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ fontSize: "14px" }}>
                                            {row.LocationName}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
                <Box sx={{ p: 2, borderTop: "1px solid #ddd", display: "flex", justifyContent: "flex-end" }}>
                    <Button variant="contained" color="primary" onClick={fLoadClick}>
                        Load
                    </Button>
                </Box>
            </Box>
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box
                    sx={{
                        width: "95%",
                        height: "92vh",
                        bgcolor: "#fff",
                        borderRadius: 2,
                        mx: "auto",
                        mt: "5vh",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2,
                            py: 1.5,
                            background: "#f5faff",
                            color: "#1e88e5",
                            borderBottom: "1px solid #d5d5d5",
                            position: "sticky",
                            top: 0,
                            zIndex: 20,
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <IconButton onClick={() => setOpenModal(false)} sx={{ color: "#1e88e5" }}>
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography variant="h6">Analysis Report</Typography>
                        </div>
                        <IconButton onClick={() => setOpenModal(false)} sx={{ color: "#1e88e5" }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                        }}
                    >
                        {reportUrl ? (
                            <iframe
                                src={reportUrl}
                                style={{ width: "100%", height: "100%", border: "none" }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    border: "1px dashed grey",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                Report preview area
                            </Box>
                        )}
                    </Box>
                </Box>
            </Modal>
        </Drawer>
    );
}
